import React from "react";
import DashboardHeader from '../../components/admincomponents/DashboardHeader';
import AddReview from '../../components/admincomponents/AddNewReview';

function AddNewReview({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <AddReview />            
    </>
  );
}

export default AddNewReview;
